import { render } from "./EinarbeitungNew.vue?vue&type=template&id=b7c45460"
import script from "./EinarbeitungNew.vue?vue&type=script&lang=js"
export * from "./EinarbeitungNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__